import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  collapse: { background: 'transparent' },
  content: { display: 'flex', flexDirection: 'column' },
});
